import { render } from "./OutlineButtons.vue?vue&type=template&id=297bb901&ts=true"
import script from "./OutlineButtons.vue?vue&type=script&lang=ts"
export * from "./OutlineButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__